// @ts-nocheck
import { z } from 'zod';
import type {
  AccessLevels,
  AccessLevelsOperationFilterInput,
  AccountFilterInput,
  AccountSortInput,
  ApplicationFilterInput,
  ApplicationSortInput,
  ApplyPolicy,
  BillingIdTypeFilterInput,
  BillingIdTypeSortInput,
  BillingIdsFilterInput,
  BillingIdsSortInput,
  BooleanOperationFilterInput,
  Ct_BalanceLineItemInput,
  Ct_BalanceResponseInput,
  CareTrackerBalanceResponseInput,
  CareTrackerConsumerInput,
  ClaimErrorResponseFilterInput,
  ClaimErrorResponseSortInput,
  ClaimFilingIndicatorFilterInput,
  ClaimFilingIndicatorSortInput,
  ClaimRemittanceResponseFilterInput,
  ClaimRemittanceResponseSortInput,
  ClaimStatisticsResponseFilterInput,
  ClaimStatisticsResponseSortInput,
  ClaimStatisticsSearchFilterInput,
  ClaimStatusRoutingFilterInput,
  ClaimStatusRoutingSortInput,
  ClaimsResponseFilterInput,
  ClaimsResponseSortInput,
  CommunicationTypeFilterInput,
  CommunicationTypeSortInput,
  ConnectionSearchResponseFilterInput,
  ConnectionSearchResponseSortInput,
  ConsumerInput,
  DataContextInput,
  DateTimeOperationFilterInput,
  DbAddressInfoFilterInput,
  DbAddressInfoSortInput,
  DbContactInfoFilterInput,
  DbContactInfoSortInput,
  DecimalOperationFilterInput,
  EligibilityRoutingFilterInput,
  EligibilityRoutingSortInput,
  EmailVendorFilterInput,
  EmailVendorSortInput,
  EnrollmentLogFilterInput,
  EnrollmentLogSortInput,
  EnrollmentStatusFilterInput,
  EnrollmentStatusSortInput,
  EraFilePaymentResponseFilterInput,
  EraFilePaymentResponseSortInput,
  FeeFilterInput,
  FeeSortInput,
  FileStatus,
  FileStatusOperationFilterInput,
  FormatTypeFilterInput,
  FormatTypeSortInput,
  GraphQlClaimSearchFiltersInput,
  GroupEnrollmentFilterInput,
  GroupEnrollmentSortInput,
  ICheckCanadaInput,
  ICheckInput,
  ICheckSaleCanadaInputAchInput,
  ICheckSaleInputAchInput,
  ICheckSaleRefundInput,
  ICheckSaleRefundInputAchInput,
  ICheckSaleRefundWithoutPreviousTransactionCanadaInput,
  ICheckSaleRefundWithoutPreviousTransactionInput,
  ICheckSaleViewDetailsInputAchInput,
  ICountryLookupInput,
  ICustomerAchInput,
  IHealthcareAmountInput,
  ILanguageLookupInput,
  IPaymentAchInput,
  IPaymentInput,
  IPaymentRefundAchInput,
  IProcessingIndicatorInput,
  IPurchaseOrderInput,
  IReceiptInput,
  ISaleExtraInput,
  ISaleExtraTransactionInput,
  ISaleInput,
  ITerminalInput,
  ITransactionAchCanadaInput,
  ITransactionAchInput,
  ITransactionInput,
  ITransactionRefundAchInput,
  InsuranceCompanySearchResponseFilterInput,
  InsuranceCompanySearchResponseSortInput,
  IntOperationFilterInput,
  LineItemInput,
  ListFilterInputTypeOfBillingIdsFilterInput,
  ListFilterInputTypeOfGroupEnrollmentFilterInput,
  ListFilterInputTypeOfPayerRoutingFilterInput,
  ListFilterInputTypeOfPreferredRoutingFilterInput,
  ListFilterInputTypeOfProviderFilterInput,
  ListFilterInputTypeOfProviderGroupFilterInput,
  ListFilterInputTypeOfUsersClientsAcctsFilterInput,
  ListFilterInputTypeOfUsersClientsAppsFilterInput,
  ListFilterInputTypeOfUsersClientsGrpsFilterInput,
  ListFilterInputTypeOfUsersClientsPermissionsFilterInput,
  LoginInput,
  LongOperationFilterInput,
  PatientFilterInput,
  PatientSortInput,
  PatientStatementsFilterInput,
  PatientStatementsResponseFilterInput,
  PatientStatementsResponseSortInput,
  PatientStatementsSearchFilterInput,
  PatientStatementsSortInput,
  PayerFilterInput,
  PayerRoutingFilterInput,
  PayerRoutingSortInput,
  PayerSortInput,
  PayloadInput,
  PaymentsRecurringPaymentFilterInput,
  PaymentsRecurringPaymentPlan,
  PaymentsRecurringPaymentPlanOperationFilterInput,
  PaymentsRecurringPaymentSortInput,
  PermissionsFilterInput,
  PermissionsSortInput,
  PreferredRoutingFilterInput,
  PreferredRoutingSortInput,
  ProcessorFilterInput,
  ProcessorSortInput,
  ProviderFilterInput,
  ProviderGroupFilterInput,
  ProviderGroupSortInput,
  ProviderSortInput,
  QualifierFilterInput,
  QualifierSortInput,
  RealTimeProcessorFilterInput,
  RealTimeProcessorSortInput,
  RecurringPaymentInput,
  SecureConnectClaimStatusTypes,
  SecureConnectClaimStatusTypesOperationFilterInput,
  SortEnumType,
  StatesFilterInput,
  StatesSortInput,
  StatisticsBaseFilterInput,
  StatisticsMissingClaimResponseFilterInput,
  StatisticsRangeSearchFilterInput,
  StatisticsRevSpringFilterInput,
  StatisticsSearchFilterInput,
  StringOperationFilterInput,
  SubmitterIdsFilterInput,
  SubmitterIdsSortInput,
  ThirdPartyBalanceResponseInput,
  ThirdPartyConsumerObjectInput,
  ThirdPartyCookiesInput,
  TwoFactorAuthenticationCodeInput,
  TwoFactorAuthenticationInput,
  UserResponseSortInput,
  UsersClientsAcctsFilterInput,
  UsersClientsAppsFilterInput,
  UsersClientsFilterInput,
  UsersClientsGrpsFilterInput,
  UsersClientsPermissionsFilterInput,
  UsersClientsSortInput,
  ZipcodeFilterInput,
  ZipcodeSortInput,
} from '../client/generated-types';

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny =>
  v !== undefined && v !== null;

export const definedNonNullAnySchema = z
  .any()
  .refine((v) => isDefinedNonNullAny(v));

export const AccessLevelsSchema = z.enum([
  'ACCOUNT',
  'BILLING_GROUP',
  'SECURE_CONNECT',
  'VENDOR',
  'VENDOR_FINANCIAL',
]);

export const ApplyPolicySchema = z.enum([
  'AFTER_RESOLVER',
  'BEFORE_RESOLVER',
  'VALIDATION',
]);

export const FileStatusSchema = z.enum([
  'COMPLETE',
  'DUPLICATE',
  'HELD',
  'IN_PROCESS',
  'MISSING',
  'RETRY',
  'TEST',
  'WAITING',
]);

export const PaymentsRecurringPaymentPlanSchema = z.enum([
  'BI_WEEKLY',
  'FORTY_EIGHT_WEEKS',
  'MONTHLY',
]);

export const SecureConnectClaimStatusTypesSchema = z.enum([
  'ARCHIVED',
  'EDITS',
  'EDITS_FAILED',
  'MANUAL_REJECT',
]);

export const SortEnumTypeSchema = z.enum(['ASC', 'DESC']);

export function AccessLevelsOperationFilterInputSchema(): z.ZodObject<
  Properties<AccessLevelsOperationFilterInput>
> {
  return z.object({
    eq: AccessLevelsSchema.nullish(),
    in: z.array(AccessLevelsSchema).nullish(),
    neq: AccessLevelsSchema.nullish(),
    nin: z.array(AccessLevelsSchema).nullish(),
  });
}

export function AccountFilterInputSchema(): z.ZodObject<
  Properties<AccountFilterInput>
> {
  return z.object({
    accountNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressCity: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressState: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressZipcode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => AccountFilterInputSchema())).nullish(),
    claimStatusDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    claimStatusStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    contactEmail: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactFax: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    creditCardExport: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    creditCardNo: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateLastDbUpdated: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateTerminated: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    ecsDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    ecsStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    eligibilityDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    eligibilityStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    eraDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    eraStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    expirationMonth: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    expirationYear: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    gemsSetupDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    gemsSetupFlag: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isActive: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    lastDbUpdatedBy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => AccountFilterInputSchema())).nullish(),
    pms: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerGroups: z.lazy(() =>
      ListFilterInputTypeOfProviderGroupFilterInputSchema().nullish(),
    ),
    providers: z.lazy(() =>
      ListFilterInputTypeOfProviderFilterInputSchema().nullish(),
    ),
    statementDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    statementStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    taxExempt: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    terminateReason: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    usersClientsAccts: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsAcctsFilterInputSchema().nullish(),
    ),
  });
}

export function AccountSortInputSchema(): z.ZodObject<
  Properties<AccountSortInput>
> {
  return z.object({
    accountNumber: SortEnumTypeSchema.nullish(),
    addressCity: SortEnumTypeSchema.nullish(),
    addressLine1: SortEnumTypeSchema.nullish(),
    addressLine2: SortEnumTypeSchema.nullish(),
    addressState: SortEnumTypeSchema.nullish(),
    addressZipcode: SortEnumTypeSchema.nullish(),
    claimStatusDate: SortEnumTypeSchema.nullish(),
    claimStatusStatus: SortEnumTypeSchema.nullish(),
    contactEmail: SortEnumTypeSchema.nullish(),
    contactFax: SortEnumTypeSchema.nullish(),
    contactName: SortEnumTypeSchema.nullish(),
    contactPhone: SortEnumTypeSchema.nullish(),
    creditCardExport: SortEnumTypeSchema.nullish(),
    creditCardNo: SortEnumTypeSchema.nullish(),
    dateLastDbUpdated: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    dateTerminated: SortEnumTypeSchema.nullish(),
    ecsDate: SortEnumTypeSchema.nullish(),
    ecsStatus: SortEnumTypeSchema.nullish(),
    eligibilityDate: SortEnumTypeSchema.nullish(),
    eligibilityStatus: SortEnumTypeSchema.nullish(),
    eraDate: SortEnumTypeSchema.nullish(),
    eraStatus: SortEnumTypeSchema.nullish(),
    expirationMonth: SortEnumTypeSchema.nullish(),
    expirationYear: SortEnumTypeSchema.nullish(),
    gemsSetupDate: SortEnumTypeSchema.nullish(),
    gemsSetupFlag: SortEnumTypeSchema.nullish(),
    isActive: SortEnumTypeSchema.nullish(),
    lastDbUpdatedBy: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    pms: SortEnumTypeSchema.nullish(),
    statementDate: SortEnumTypeSchema.nullish(),
    statementStatus: SortEnumTypeSchema.nullish(),
    taxExempt: SortEnumTypeSchema.nullish(),
    terminateReason: SortEnumTypeSchema.nullish(),
  });
}

export function ApplicationFilterInputSchema(): z.ZodObject<
  Properties<ApplicationFilterInput>
> {
  return z.object({
    alphaII: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => ApplicationFilterInputSchema())).nullish(),
    batch277ca: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batch277u: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batchCsv: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batchHumanReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    batchMachineReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    batchxml: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    careTracker: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ftpKey: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    genericProvider: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    humanReadable271: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    inputGenerates999: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    message: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    newStatements: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ApplicationFilterInputSchema())).nullish(),
    providers: z.lazy(() =>
      ListFilterInputTypeOfProviderFilterInputSchema().nullish(),
    ),
    rcm: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    rejectPrintClaims: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    remit277ca: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remit277u: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitCsv: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitCsvDaily: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitEraSummary: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitHumanReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    remitMachineReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    remitXml: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    usersClientsApps: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsAppsFilterInputSchema().nullish(),
    ),
  });
}

export function ApplicationSortInputSchema(): z.ZodObject<
  Properties<ApplicationSortInput>
> {
  return z.object({
    alphaII: SortEnumTypeSchema.nullish(),
    batch277ca: SortEnumTypeSchema.nullish(),
    batch277u: SortEnumTypeSchema.nullish(),
    batchCsv: SortEnumTypeSchema.nullish(),
    batchHumanReadable: SortEnumTypeSchema.nullish(),
    batchMachineReadable: SortEnumTypeSchema.nullish(),
    batchxml: SortEnumTypeSchema.nullish(),
    careTracker: SortEnumTypeSchema.nullish(),
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
    ftpKey: SortEnumTypeSchema.nullish(),
    genericProvider: SortEnumTypeSchema.nullish(),
    humanReadable271: SortEnumTypeSchema.nullish(),
    inputGenerates999: SortEnumTypeSchema.nullish(),
    message: SortEnumTypeSchema.nullish(),
    newStatements: SortEnumTypeSchema.nullish(),
    rcm: SortEnumTypeSchema.nullish(),
    rejectPrintClaims: SortEnumTypeSchema.nullish(),
    remit277ca: SortEnumTypeSchema.nullish(),
    remit277u: SortEnumTypeSchema.nullish(),
    remitCsv: SortEnumTypeSchema.nullish(),
    remitCsvDaily: SortEnumTypeSchema.nullish(),
    remitEraSummary: SortEnumTypeSchema.nullish(),
    remitHumanReadable: SortEnumTypeSchema.nullish(),
    remitMachineReadable: SortEnumTypeSchema.nullish(),
    remitXml: SortEnumTypeSchema.nullish(),
  });
}

export function BillingIdTypeFilterInputSchema(): z.ZodObject<
  Properties<BillingIdTypeFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => BillingIdTypeFilterInputSchema())).nullish(),
    billingIds: z.lazy(() =>
      ListFilterInputTypeOfBillingIdsFilterInputSchema().nullish(),
    ),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => BillingIdTypeFilterInputSchema())).nullish(),
  });
}

export function BillingIdTypeSortInputSchema(): z.ZodObject<
  Properties<BillingIdTypeSortInput>
> {
  return z.object({
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
  });
}

export function BillingIdsFilterInputSchema(): z.ZodObject<
  Properties<BillingIdsFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => BillingIdsFilterInputSchema())).nullish(),
    billingId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    billingIdType: z.lazy(() => BillingIdTypeFilterInputSchema().nullish()),
    billingIdTypeCode: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    lastUpdatedBy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => BillingIdsFilterInputSchema())).nullish(),
    providerGroup: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
    providerGroupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    rowId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    status: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function BillingIdsSortInputSchema(): z.ZodObject<
  Properties<BillingIdsSortInput>
> {
  return z.object({
    billingId: SortEnumTypeSchema.nullish(),
    billingIdType: z.lazy(() => BillingIdTypeSortInputSchema().nullish()),
    billingIdTypeCode: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    lastUpdatedBy: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    providerGroup: z.lazy(() => ProviderGroupSortInputSchema().nullish()),
    providerGroupId: SortEnumTypeSchema.nullish(),
    providerId: SortEnumTypeSchema.nullish(),
    rowId: SortEnumTypeSchema.nullish(),
    status: SortEnumTypeSchema.nullish(),
  });
}

export function BooleanOperationFilterInputSchema(): z.ZodObject<
  Properties<BooleanOperationFilterInput>
> {
  return z.object({
    eq: z.boolean().nullish(),
    neq: z.boolean().nullish(),
  });
}

export function Ct_BalanceLineItemInputSchema(): z.ZodObject<
  Properties<Ct_BalanceLineItemInput>
> {
  return z.object({
    accountNumber: z.string().nullish(),
    amountDue: z.string().nullish(),
    amountPaid: z.string().nullish(),
    firstName: z.string().nullish(),
    fullName: z.string().nullish(),
    gatewayRoutingCode: z.string().nullish(),
    lastName: z.string().nullish(),
    middleName: z.string().nullish(),
    placeOfServiceLocation: z.string().nullish(),
    providerType: z.string().nullish(),
    serviceDate: z.string().nullish(),
    serviceEndDate: z.string().nullish(),
    serviceProvider: z.string().nullish(),
    serviceStartDate: z.string().nullish(),
  });
}

export function Ct_BalanceResponseInputSchema(): z.ZodObject<
  Properties<Ct_BalanceResponseInput>
> {
  return z.object({
    address1: z.string().nullish(),
    address2: z.string().nullish(),
    amountDue: z.string().nullish(),
    city: z.string().nullish(),
    consumerNumber: z.string().nullish(),
    country: z.string().nullish(),
    dateOfBirth: z.string().nullish(),
    firstName: z.string().nullish(),
    gender: z.string().nullish(),
    lastName: z.string().nullish(),
    lineItem: z
      .array(z.lazy(() => Ct_BalanceLineItemInputSchema().nullable()))
      .nullish(),
    phone: z.string().nullish(),
    state: z.string().nullish(),
    zip: z.string().nullish(),
  });
}

export function CareTrackerBalanceResponseInputSchema(): z.ZodObject<
  Properties<CareTrackerBalanceResponseInput>
> {
  return z.object({
    response: z.lazy(() => Ct_BalanceResponseInputSchema().nullish()),
    tranId: z.string().nullish(),
    transaction_id: z.string().nullish(),
  });
}

export function CareTrackerConsumerInputSchema(): z.ZodObject<
  Properties<CareTrackerConsumerInput>
> {
  return z.object({
    payload: z.lazy(() => PayloadInputSchema().nullish()),
  });
}

export function ClaimErrorResponseFilterInputSchema(): z.ZodObject<
  Properties<ClaimErrorResponseFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ClaimErrorResponseFilterInputSchema())).nullish(),
    claimId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    errorDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    errorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    lxCounter: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    messageInfo: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    messageText: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ClaimErrorResponseFilterInputSchema())).nullish(),
    providerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ClaimErrorResponseSortInputSchema(): z.ZodObject<
  Properties<ClaimErrorResponseSortInput>
> {
  return z.object({
    claimId: SortEnumTypeSchema.nullish(),
    errorDate: SortEnumTypeSchema.nullish(),
    errorId: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    lxCounter: SortEnumTypeSchema.nullish(),
    messageInfo: SortEnumTypeSchema.nullish(),
    messageText: SortEnumTypeSchema.nullish(),
    providerId: SortEnumTypeSchema.nullish(),
  });
}

export function ClaimFilingIndicatorFilterInputSchema(): z.ZodObject<
  Properties<ClaimFilingIndicatorFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => ClaimFilingIndicatorFilterInputSchema()))
      .nullish(),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => ClaimFilingIndicatorFilterInputSchema()))
      .nullish(),
  });
}

export function ClaimFilingIndicatorSortInputSchema(): z.ZodObject<
  Properties<ClaimFilingIndicatorSortInput>
> {
  return z.object({
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
  });
}

export function ClaimRemittanceResponseFilterInputSchema(): z.ZodObject<
  Properties<ClaimRemittanceResponseFilterInput>
> {
  return z.object({
    actualFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z
      .array(z.lazy(() => ClaimRemittanceResponseFilterInputSchema()))
      .nullish(),
    apicategory: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    carrier: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    carrierProcessDate: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    carrierProcessTime: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    carrierTraceNumber: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    checkNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimCharges: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    claimId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimPaidAmount: z.lazy(() =>
      DecimalOperationFilterInputSchema().nullish(),
    ),
    claimStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    creationDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    csvFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateOfService: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    exportDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    fileName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    filename277ca: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    inputData: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    npiOrTaxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => ClaimRemittanceResponseFilterInputSchema()))
      .nullish(),
    outputFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    patientAccountNumber: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    patientName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerTraceNumber: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    processFlag: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerGroupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    reportName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    serviceProviderNPI: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    xmlFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ClaimRemittanceResponseSortInputSchema(): z.ZodObject<
  Properties<ClaimRemittanceResponseSortInput>
> {
  return z.object({
    actualFilename: SortEnumTypeSchema.nullish(),
    apicategory: SortEnumTypeSchema.nullish(),
    carrier: SortEnumTypeSchema.nullish(),
    carrierProcessDate: SortEnumTypeSchema.nullish(),
    carrierProcessTime: SortEnumTypeSchema.nullish(),
    carrierTraceNumber: SortEnumTypeSchema.nullish(),
    checkNumber: SortEnumTypeSchema.nullish(),
    claimCharges: SortEnumTypeSchema.nullish(),
    claimId: SortEnumTypeSchema.nullish(),
    claimPaidAmount: SortEnumTypeSchema.nullish(),
    claimStatus: SortEnumTypeSchema.nullish(),
    creationDate: SortEnumTypeSchema.nullish(),
    csvFilename: SortEnumTypeSchema.nullish(),
    dateOfService: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
    exportDate: SortEnumTypeSchema.nullish(),
    fileName: SortEnumTypeSchema.nullish(),
    filename277ca: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    inputData: SortEnumTypeSchema.nullish(),
    npiOrTaxId: SortEnumTypeSchema.nullish(),
    outputFilename: SortEnumTypeSchema.nullish(),
    patientAccountNumber: SortEnumTypeSchema.nullish(),
    patientName: SortEnumTypeSchema.nullish(),
    payerId: SortEnumTypeSchema.nullish(),
    payerName: SortEnumTypeSchema.nullish(),
    payerTraceNumber: SortEnumTypeSchema.nullish(),
    processFlag: SortEnumTypeSchema.nullish(),
    providerGroupId: SortEnumTypeSchema.nullish(),
    providerId: SortEnumTypeSchema.nullish(),
    reportName: SortEnumTypeSchema.nullish(),
    serviceProviderNPI: SortEnumTypeSchema.nullish(),
    xmlFilename: SortEnumTypeSchema.nullish(),
  });
}

export function ClaimStatisticsResponseFilterInputSchema(): z.ZodObject<
  Properties<ClaimStatisticsResponseFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => ClaimStatisticsResponseFilterInputSchema()))
      .nullish(),
    category: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    count: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => ClaimStatisticsResponseFilterInputSchema()))
      .nullish(),
    totalCharges: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
  });
}

export function ClaimStatisticsResponseSortInputSchema(): z.ZodObject<
  Properties<ClaimStatisticsResponseSortInput>
> {
  return z.object({
    category: SortEnumTypeSchema.nullish(),
    count: SortEnumTypeSchema.nullish(),
    totalCharges: SortEnumTypeSchema.nullish(),
  });
}

export function ClaimStatisticsSearchFilterInputSchema(): z.ZodObject<
  Properties<ClaimStatisticsSearchFilterInput>
> {
  return z.object({
    account: z.string().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    groupId: z.string().nullish(),
    limit: z.number().nullish(),
    pms: z.string().nullish(),
    skip: z.number().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
  });
}

export function ClaimStatusRoutingFilterInputSchema(): z.ZodObject<
  Properties<ClaimStatusRoutingFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ClaimStatusRoutingFilterInputSchema())).nullish(),
    ediId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    nm1Upper: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    onlineBatch: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ClaimStatusRoutingFilterInputSchema())).nullish(),
    payerName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    scId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ClaimStatusRoutingSortInputSchema(): z.ZodObject<
  Properties<ClaimStatusRoutingSortInput>
> {
  return z.object({
    ediId: SortEnumTypeSchema.nullish(),
    groupId: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    nm1Upper: SortEnumTypeSchema.nullish(),
    onlineBatch: SortEnumTypeSchema.nullish(),
    payerName: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    scId: SortEnumTypeSchema.nullish(),
  });
}

export function ClaimsResponseFilterInputSchema(): z.ZodObject<
  Properties<ClaimsResponseFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => ClaimsResponseFilterInputSchema())).nullish(),
    batchNumber: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    batchStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    billingNpi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    billingProviderFirstname: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    billingProviderLastname: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    billingProviderMi: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    billingTaxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    carrierProcessDate: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    carrierProcessTime: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    claimId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimStatusCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    csvFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    customerInputFilename: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    dateOfSubmission: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    filename277ca: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    firstServiceDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    formatType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    inputFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    inputFormat: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    inputSeqNumber: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    insurancePlanName: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    insuredName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    neicId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ClaimsResponseFilterInputSchema())).nullish(),
    outputBatchNumber: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    outputFormat: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    patientAccountNumber: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    patientFirstname: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    patientLastname: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    patientMi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    patientName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerResponibility: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerFirstname: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    providerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerLastname: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    providerMi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    renderingNpi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    reportFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    reportId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    statusFlag: z.lazy(() =>
      SecureConnectClaimStatusTypesOperationFilterInputSchema().nullish(),
    ),
    totalCharges: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    transmitFilename: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    xmlFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ClaimsResponseSortInputSchema(): z.ZodObject<
  Properties<ClaimsResponseSortInput>
> {
  return z.object({
    batchNumber: SortEnumTypeSchema.nullish(),
    batchStatus: SortEnumTypeSchema.nullish(),
    billingNpi: SortEnumTypeSchema.nullish(),
    billingProviderFirstname: SortEnumTypeSchema.nullish(),
    billingProviderLastname: SortEnumTypeSchema.nullish(),
    billingProviderMi: SortEnumTypeSchema.nullish(),
    billingTaxId: SortEnumTypeSchema.nullish(),
    carrierProcessDate: SortEnumTypeSchema.nullish(),
    carrierProcessTime: SortEnumTypeSchema.nullish(),
    claimId: SortEnumTypeSchema.nullish(),
    claimStatus: SortEnumTypeSchema.nullish(),
    claimStatusCode: SortEnumTypeSchema.nullish(),
    csvFilename: SortEnumTypeSchema.nullish(),
    customerInputFilename: SortEnumTypeSchema.nullish(),
    dateOfSubmission: SortEnumTypeSchema.nullish(),
    filename277ca: SortEnumTypeSchema.nullish(),
    firstServiceDate: SortEnumTypeSchema.nullish(),
    formatType: SortEnumTypeSchema.nullish(),
    inputFilename: SortEnumTypeSchema.nullish(),
    inputFormat: SortEnumTypeSchema.nullish(),
    inputSeqNumber: SortEnumTypeSchema.nullish(),
    insurancePlanName: SortEnumTypeSchema.nullish(),
    insuredName: SortEnumTypeSchema.nullish(),
    neicId: SortEnumTypeSchema.nullish(),
    outputBatchNumber: SortEnumTypeSchema.nullish(),
    outputFormat: SortEnumTypeSchema.nullish(),
    patientAccountNumber: SortEnumTypeSchema.nullish(),
    patientFirstname: SortEnumTypeSchema.nullish(),
    patientLastname: SortEnumTypeSchema.nullish(),
    patientMi: SortEnumTypeSchema.nullish(),
    patientName: SortEnumTypeSchema.nullish(),
    payerId: SortEnumTypeSchema.nullish(),
    payerResponibility: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    providerFirstname: SortEnumTypeSchema.nullish(),
    providerId: SortEnumTypeSchema.nullish(),
    providerLastname: SortEnumTypeSchema.nullish(),
    providerMi: SortEnumTypeSchema.nullish(),
    renderingNpi: SortEnumTypeSchema.nullish(),
    reportFilename: SortEnumTypeSchema.nullish(),
    reportId: SortEnumTypeSchema.nullish(),
    statusFlag: SortEnumTypeSchema.nullish(),
    totalCharges: SortEnumTypeSchema.nullish(),
    transmitFilename: SortEnumTypeSchema.nullish(),
    xmlFilename: SortEnumTypeSchema.nullish(),
  });
}

export function CommunicationTypeFilterInputSchema(): z.ZodObject<
  Properties<CommunicationTypeFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => CommunicationTypeFilterInputSchema())).nullish(),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => CommunicationTypeFilterInputSchema())).nullish(),
  });
}

export function CommunicationTypeSortInputSchema(): z.ZodObject<
  Properties<CommunicationTypeSortInput>
> {
  return z.object({
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
  });
}

export function ConnectionSearchResponseFilterInputSchema(): z.ZodObject<
  Properties<ConnectionSearchResponseFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => ConnectionSearchResponseFilterInputSchema()))
      .nullish(),
    ftpHost: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ftpKey: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ftpType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ftpUserId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => ConnectionSearchResponseFilterInputSchema()))
      .nullish(),
    queue: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    status: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ConnectionSearchResponseSortInputSchema(): z.ZodObject<
  Properties<ConnectionSearchResponseSortInput>
> {
  return z.object({
    ftpHost: SortEnumTypeSchema.nullish(),
    ftpKey: SortEnumTypeSchema.nullish(),
    ftpType: SortEnumTypeSchema.nullish(),
    ftpUserId: SortEnumTypeSchema.nullish(),
    queue: SortEnumTypeSchema.nullish(),
    status: SortEnumTypeSchema.nullish(),
  });
}

export function ConsumerInputSchema(): z.ZodObject<Properties<ConsumerInput>> {
  return z.object({
    address1: z.string().nullish(),
    amountDue: z.string().nullish(),
    city: z.string().nullish(),
    country: z.string().nullish(),
    dateOfBirth: z.string().nullish(),
    firstName: z.string().nullish(),
    fullName: z.string().nullish(),
    lastName: z.string().nullish(),
    phone: z.string().nullish(),
    state: z.string().nullish(),
    zip: z.string().nullish(),
  });
}

export function DataContextInputSchema(): z.ZodObject<
  Properties<DataContextInput>
> {
  return z.object({
    consumer: z.lazy(() => ConsumerInputSchema().nullish()),
    lineItem: z.array(z.lazy(() => LineItemInputSchema().nullable())).nullish(),
  });
}

export function DateTimeOperationFilterInputSchema(): z.ZodObject<
  Properties<DateTimeOperationFilterInput>
> {
  return z.object({
    eq: definedNonNullAnySchema.nullish(),
    gt: definedNonNullAnySchema.nullish(),
    gte: definedNonNullAnySchema.nullish(),
    in: z.array(definedNonNullAnySchema.nullable()).nullish(),
    lt: definedNonNullAnySchema.nullish(),
    lte: definedNonNullAnySchema.nullish(),
    neq: definedNonNullAnySchema.nullish(),
    ngt: definedNonNullAnySchema.nullish(),
    ngte: definedNonNullAnySchema.nullish(),
    nin: z.array(definedNonNullAnySchema.nullable()).nullish(),
    nlt: definedNonNullAnySchema.nullish(),
    nlte: definedNonNullAnySchema.nullish(),
  });
}

export function DbAddressInfoFilterInputSchema(): z.ZodObject<
  Properties<DbAddressInfoFilterInput>
> {
  return z.object({
    addressInfoId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    addressLine1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => DbAddressInfoFilterInputSchema())).nullish(),
    city: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => DbAddressInfoFilterInputSchema())).nullish(),
    state: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    zipcode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function DbAddressInfoSortInputSchema(): z.ZodObject<
  Properties<DbAddressInfoSortInput>
> {
  return z.object({
    addressInfoId: SortEnumTypeSchema.nullish(),
    addressLine1: SortEnumTypeSchema.nullish(),
    addressLine2: SortEnumTypeSchema.nullish(),
    city: SortEnumTypeSchema.nullish(),
    state: SortEnumTypeSchema.nullish(),
    zipcode: SortEnumTypeSchema.nullish(),
  });
}

export function DbContactInfoFilterInputSchema(): z.ZodObject<
  Properties<DbContactInfoFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => DbContactInfoFilterInputSchema())).nullish(),
    contactInfoId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    emailAddress: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => DbContactInfoFilterInputSchema())).nullish(),
    primaryPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    primarySupportsSms: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    secondaryPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    secondarySupportsSms: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
  });
}

export function DbContactInfoSortInputSchema(): z.ZodObject<
  Properties<DbContactInfoSortInput>
> {
  return z.object({
    contactInfoId: SortEnumTypeSchema.nullish(),
    emailAddress: SortEnumTypeSchema.nullish(),
    primaryPhone: SortEnumTypeSchema.nullish(),
    primarySupportsSms: SortEnumTypeSchema.nullish(),
    secondaryPhone: SortEnumTypeSchema.nullish(),
    secondarySupportsSms: SortEnumTypeSchema.nullish(),
  });
}

export function DecimalOperationFilterInputSchema(): z.ZodObject<
  Properties<DecimalOperationFilterInput>
> {
  return z.object({
    eq: definedNonNullAnySchema.nullish(),
    gt: definedNonNullAnySchema.nullish(),
    gte: definedNonNullAnySchema.nullish(),
    in: z.array(definedNonNullAnySchema.nullable()).nullish(),
    lt: definedNonNullAnySchema.nullish(),
    lte: definedNonNullAnySchema.nullish(),
    neq: definedNonNullAnySchema.nullish(),
    ngt: definedNonNullAnySchema.nullish(),
    ngte: definedNonNullAnySchema.nullish(),
    nin: z.array(definedNonNullAnySchema.nullable()).nullish(),
    nlt: definedNonNullAnySchema.nullish(),
    nlte: definedNonNullAnySchema.nullish(),
  });
}

export function EligibilityRoutingFilterInputSchema(): z.ZodObject<
  Properties<EligibilityRoutingFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => EligibilityRoutingFilterInputSchema())).nullish(),
    changeReceiverNonPersonEntity: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    ediId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ediidQualifier: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nm1Upper: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => EligibilityRoutingFilterInputSchema())).nullish(),
    payerName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    removePrv: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    removeReceiverRef0b: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    removeReceiverRefTj: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    removeRefSy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    removeSubscriberAddress: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    removeSubscriberDtp102: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    removeSubscriberDtp291: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    removeSubscriberGender: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    removeSubscriberNm1Mi: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    scId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function EligibilityRoutingSortInputSchema(): z.ZodObject<
  Properties<EligibilityRoutingSortInput>
> {
  return z.object({
    changeReceiverNonPersonEntity: SortEnumTypeSchema.nullish(),
    ediId: SortEnumTypeSchema.nullish(),
    ediidQualifier: SortEnumTypeSchema.nullish(),
    groupId: SortEnumTypeSchema.nullish(),
    nm1Upper: SortEnumTypeSchema.nullish(),
    payerName: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    removePrv: SortEnumTypeSchema.nullish(),
    removeReceiverRef0b: SortEnumTypeSchema.nullish(),
    removeReceiverRefTj: SortEnumTypeSchema.nullish(),
    removeRefSy: SortEnumTypeSchema.nullish(),
    removeSubscriberAddress: SortEnumTypeSchema.nullish(),
    removeSubscriberDtp102: SortEnumTypeSchema.nullish(),
    removeSubscriberDtp291: SortEnumTypeSchema.nullish(),
    removeSubscriberGender: SortEnumTypeSchema.nullish(),
    removeSubscriberNm1Mi: SortEnumTypeSchema.nullish(),
    scId: SortEnumTypeSchema.nullish(),
  });
}

export function EmailVendorFilterInputSchema(): z.ZodObject<
  Properties<EmailVendorFilterInput>
> {
  return z.object({
    active: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => EmailVendorFilterInputSchema())).nullish(),
    authType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    authValue: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    baseUrl: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    createdBy: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => EmailVendorFilterInputSchema())).nullish(),
    sendEmailUrl: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    updatedBy: z.lazy(() => IntOperationFilterInputSchema().nullish()),
  });
}

export function EmailVendorSortInputSchema(): z.ZodObject<
  Properties<EmailVendorSortInput>
> {
  return z.object({
    active: SortEnumTypeSchema.nullish(),
    authType: SortEnumTypeSchema.nullish(),
    authValue: SortEnumTypeSchema.nullish(),
    baseUrl: SortEnumTypeSchema.nullish(),
    createdAt: SortEnumTypeSchema.nullish(),
    createdBy: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    sendEmailUrl: SortEnumTypeSchema.nullish(),
    updatedAt: SortEnumTypeSchema.nullish(),
    updatedBy: SortEnumTypeSchema.nullish(),
  });
}

export function EnrollmentLogFilterInputSchema(): z.ZodObject<
  Properties<EnrollmentLogFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => EnrollmentLogFilterInputSchema())).nullish(),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => EnrollmentLogFilterInputSchema())).nullish(),
    seqNo: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    status: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    updated: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    userId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    userName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function EnrollmentLogSortInputSchema(): z.ZodObject<
  Properties<EnrollmentLogSortInput>
> {
  return z.object({
    id: SortEnumTypeSchema.nullish(),
    seqNo: SortEnumTypeSchema.nullish(),
    status: SortEnumTypeSchema.nullish(),
    updated: SortEnumTypeSchema.nullish(),
    userId: SortEnumTypeSchema.nullish(),
    userName: SortEnumTypeSchema.nullish(),
  });
}

export function EnrollmentStatusFilterInputSchema(): z.ZodObject<
  Properties<EnrollmentStatusFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => EnrollmentStatusFilterInputSchema())).nullish(),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => EnrollmentStatusFilterInputSchema())).nullish(),
  });
}

export function EnrollmentStatusSortInputSchema(): z.ZodObject<
  Properties<EnrollmentStatusSortInput>
> {
  return z.object({
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
  });
}

export function EraFilePaymentResponseFilterInputSchema(): z.ZodObject<
  Properties<EraFilePaymentResponseFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => EraFilePaymentResponseFilterInputSchema()))
      .nullish(),
    billingNpi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    billingTaxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimCount: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    dateReceived: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    effectiveDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    fileId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    groupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    inputFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => EraFilePaymentResponseFilterInputSchema()))
      .nullish(),
    outputFilename: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payerTaxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    paymentAmount: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    status: z.lazy(() => FileStatusOperationFilterInputSchema().nullish()),
    submitterId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    submitterName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    traceNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    transmissionDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
  });
}

export function EraFilePaymentResponseSortInputSchema(): z.ZodObject<
  Properties<EraFilePaymentResponseSortInput>
> {
  return z.object({
    billingNpi: SortEnumTypeSchema.nullish(),
    billingTaxId: SortEnumTypeSchema.nullish(),
    claimCount: SortEnumTypeSchema.nullish(),
    dateReceived: SortEnumTypeSchema.nullish(),
    effectiveDate: SortEnumTypeSchema.nullish(),
    fileId: SortEnumTypeSchema.nullish(),
    groupId: SortEnumTypeSchema.nullish(),
    inputFilename: SortEnumTypeSchema.nullish(),
    outputFilename: SortEnumTypeSchema.nullish(),
    payerId: SortEnumTypeSchema.nullish(),
    payerName: SortEnumTypeSchema.nullish(),
    payerTaxId: SortEnumTypeSchema.nullish(),
    paymentAmount: SortEnumTypeSchema.nullish(),
    status: SortEnumTypeSchema.nullish(),
    submitterId: SortEnumTypeSchema.nullish(),
    submitterName: SortEnumTypeSchema.nullish(),
    traceNumber: SortEnumTypeSchema.nullish(),
    transmissionDate: SortEnumTypeSchema.nullish(),
  });
}

export function FeeFilterInputSchema(): z.ZodObject<
  Properties<FeeFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => FeeFilterInputSchema())).nullish(),
    claimStatusNonPar: z.lazy(() =>
      DecimalOperationFilterInputSchema().nullish(),
    ),
    claimStatusPar: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateTerminate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    ecsFeeNonPar: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    ecsFeePar: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    ediFee: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    eligibilityFeeNonPar: z.lazy(() =>
      DecimalOperationFilterInputSchema().nullish(),
    ),
    eligibilityFeePar: z.lazy(() =>
      DecimalOperationFilterInputSchema().nullish(),
    ),
    eraFeeNonPar: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    eraFeePar: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    freeDays: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    installFee: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => FeeFilterInputSchema())).nullish(),
    paperClaims: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    providerGroups: z.lazy(() =>
      ListFilterInputTypeOfProviderGroupFilterInputSchema().nullish(),
    ),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    serviceFee: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    statementsAdditionalPages: z.lazy(() =>
      DecimalOperationFilterInputSchema().nullish(),
    ),
    statementsFirstPage: z.lazy(() =>
      DecimalOperationFilterInputSchema().nullish(),
    ),
    taxRate: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
  });
}

export function FeeSortInputSchema(): z.ZodObject<Properties<FeeSortInput>> {
  return z.object({
    claimStatusNonPar: SortEnumTypeSchema.nullish(),
    claimStatusPar: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    dateTerminate: SortEnumTypeSchema.nullish(),
    ecsFeeNonPar: SortEnumTypeSchema.nullish(),
    ecsFeePar: SortEnumTypeSchema.nullish(),
    ediFee: SortEnumTypeSchema.nullish(),
    eligibilityFeeNonPar: SortEnumTypeSchema.nullish(),
    eligibilityFeePar: SortEnumTypeSchema.nullish(),
    eraFeeNonPar: SortEnumTypeSchema.nullish(),
    eraFeePar: SortEnumTypeSchema.nullish(),
    freeDays: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    installFee: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    paperClaims: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    serviceFee: SortEnumTypeSchema.nullish(),
    statementsAdditionalPages: SortEnumTypeSchema.nullish(),
    statementsFirstPage: SortEnumTypeSchema.nullish(),
    taxRate: SortEnumTypeSchema.nullish(),
  });
}

export function FileStatusOperationFilterInputSchema(): z.ZodObject<
  Properties<FileStatusOperationFilterInput>
> {
  return z.object({
    eq: FileStatusSchema.nullish(),
    in: z.array(FileStatusSchema).nullish(),
    neq: FileStatusSchema.nullish(),
    nin: z.array(FileStatusSchema).nullish(),
  });
}

export function FormatTypeFilterInputSchema(): z.ZodObject<
  Properties<FormatTypeFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => FormatTypeFilterInputSchema())).nullish(),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => FormatTypeFilterInputSchema())).nullish(),
  });
}

export function FormatTypeSortInputSchema(): z.ZodObject<
  Properties<FormatTypeSortInput>
> {
  return z.object({
    description: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
  });
}

export function GraphQlClaimSearchFiltersInputSchema(): z.ZodObject<
  Properties<GraphQlClaimSearchFiltersInput>
> {
  return z.object({
    billingNPI: z.string().nullish(),
    claimId: z.string().nullish(),
    claimStatus: z.string().nullish(),
    claimsDateType: z.string().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    formatType: z.string().nullish(),
    group: z.string().nullish(),
    patientAccountNumber: z.string().nullish(),
    patientName: z.string().nullish(),
    payer: z.string().nullish(),
    receiver: z.string().nullish(),
    renderNPI: z.string().nullish(),
    showLast: z.number().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
    taxID: z.string().nullish(),
  });
}

export function GroupEnrollmentFilterInputSchema(): z.ZodObject<
  Properties<GroupEnrollmentFilterInput>
> {
  return z.object({
    actionNotes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    agreementApprovedDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    agreementDeniedDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    agreementSentDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    agreementSubmittedDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    and: z.array(z.lazy(() => GroupEnrollmentFilterInputSchema())).nullish(),
    caseNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    ediId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    enrollmentId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    enrollmentOwner: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    enrollmentStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    enrollmentType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    followUpDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    lastUpdatedBy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    message: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    npi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => GroupEnrollmentFilterInputSchema())).nullish(),
    payer: z.lazy(() => PayerFilterInputSchema().nullish()),
    payerId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    pms: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    provider: z.lazy(() => ProviderFilterInputSchema().nullish()),
    providerGroup: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
    seqNo: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    taxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    useApi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function GroupEnrollmentSortInputSchema(): z.ZodObject<
  Properties<GroupEnrollmentSortInput>
> {
  return z.object({
    actionNotes: SortEnumTypeSchema.nullish(),
    agreementApprovedDate: SortEnumTypeSchema.nullish(),
    agreementDeniedDate: SortEnumTypeSchema.nullish(),
    agreementSentDate: SortEnumTypeSchema.nullish(),
    agreementSubmittedDate: SortEnumTypeSchema.nullish(),
    caseNumber: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    ediId: SortEnumTypeSchema.nullish(),
    enrollmentId: SortEnumTypeSchema.nullish(),
    enrollmentOwner: SortEnumTypeSchema.nullish(),
    enrollmentStatus: SortEnumTypeSchema.nullish(),
    enrollmentType: SortEnumTypeSchema.nullish(),
    followUpDate: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    lastUpdatedBy: SortEnumTypeSchema.nullish(),
    message: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    npi: SortEnumTypeSchema.nullish(),
    payer: z.lazy(() => PayerSortInputSchema().nullish()),
    payerId: SortEnumTypeSchema.nullish(),
    pms: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    provider: z.lazy(() => ProviderSortInputSchema().nullish()),
    providerGroup: z.lazy(() => ProviderGroupSortInputSchema().nullish()),
    seqNo: SortEnumTypeSchema.nullish(),
    taxId: SortEnumTypeSchema.nullish(),
    useApi: SortEnumTypeSchema.nullish(),
  });
}

export function ICheckCanadaInputSchema(): z.ZodObject<
  Properties<ICheckCanadaInput>
> {
  return z.object({
    account_number: z.string(),
    account_type: z.string().nullish(),
    branch_transit_number: z.string(),
    financial_institution_number: z.string(),
    token: z.string().nullish(),
  });
}

export function ICheckInputSchema(): z.ZodObject<Properties<ICheckInput>> {
  return z.object({
    account_number: z.string(),
    account_type: z.string().nullish(),
    routing_number: z.string(),
    token: z.string().nullish(),
  });
}

export function ICheckSaleCanadaInputAchInputSchema(): z.ZodObject<
  Properties<ICheckSaleCanadaInputAchInput>
> {
  return z.object({
    balance_response: z.lazy(() =>
      ThirdPartyBalanceResponseInputSchema().nullish(),
    ),
    check: z.lazy(() => ICheckCanadaInputSchema()),
    consumer: z.lazy(() => ThirdPartyConsumerObjectInputSchema().nullish()),
    customer: z.lazy(() => ICustomerAchInputSchema()),
    patientId: z.string().nullish(),
    payment: z.lazy(() => IPaymentAchInputSchema()),
    reference_id: z.string().nullish(),
    transaction: z.lazy(() => ITransactionAchCanadaInputSchema()),
  });
}

export function ICheckSaleInputAchInputSchema(): z.ZodObject<
  Properties<ICheckSaleInputAchInput>
> {
  return z.object({
    balance_response: z.lazy(() =>
      ThirdPartyBalanceResponseInputSchema().nullish(),
    ),
    check: z.lazy(() => ICheckInputSchema()),
    consumer: z.lazy(() => ThirdPartyConsumerObjectInputSchema().nullish()),
    customer: z.lazy(() => ICustomerAchInputSchema()),
    patientId: z.string().nullish(),
    payment: z.lazy(() => IPaymentAchInputSchema()),
    reference_id: z.string().nullish(),
    transaction: z.lazy(() => ITransactionAchInputSchema()),
  });
}

export function ICheckSaleRefundInputSchema(): z.ZodObject<
  Properties<ICheckSaleRefundInput>
> {
  return z.object({
    account_type: z.string().nullish(),
  });
}

export function ICheckSaleRefundInputAchInputSchema(): z.ZodObject<
  Properties<ICheckSaleRefundInputAchInput>
> {
  return z.object({
    check: z.lazy(() => ICheckSaleRefundInputSchema()),
    payment: z.lazy(() => IPaymentRefundAchInputSchema()),
    referenceId: z.string(),
    transaction: z.lazy(() => ITransactionRefundAchInputSchema()),
  });
}

export function ICheckSaleRefundWithoutPreviousTransactionCanadaInputSchema(): z.ZodObject<
  Properties<ICheckSaleRefundWithoutPreviousTransactionCanadaInput>
> {
  return z.object({
    account_number: z.string(),
    account_type: z.string(),
    branch_transit_number: z.string(),
    financial_institution_number: z.string(),
  });
}

export function ICheckSaleRefundWithoutPreviousTransactionInputSchema(): z.ZodObject<
  Properties<ICheckSaleRefundWithoutPreviousTransactionInput>
> {
  return z.object({
    account_number: z.string(),
    account_type: z.string(),
    routing_number: z.string(),
  });
}

export function ICheckSaleViewDetailsInputAchInputSchema(): z.ZodObject<
  Properties<ICheckSaleViewDetailsInputAchInput>
> {
  return z.object({
    checksale_id: z.string().nullish(),
    reference_id: z.string().nullish(),
  });
}

export function ICountryLookupInputSchema(): z.ZodObject<
  Properties<ICountryLookupInput>
> {
  return z.object({
    countryAlphaCode: z.string().nullish(),
    countryName: z.string().nullish(),
  });
}

export function ICustomerAchInputSchema(): z.ZodObject<
  Properties<ICustomerAchInput>
> {
  return z.object({
    business_name: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    middle_name: z.string().nullish(),
  });
}

export function IHealthcareAmountInputSchema(): z.ZodObject<
  Properties<IHealthcareAmountInput>
> {
  return z.object({
    clinical_amount: z.string(),
    copay_amount: z.string(),
    dental_amount: z.string(),
    healthcare_total_amount: z.string(),
    prescription_amount: z.string(),
    vision_amount: z.string(),
  });
}

export function ILanguageLookupInputSchema(): z.ZodObject<
  Properties<ILanguageLookupInput>
> {
  return z.object({
    countryAlphaCode: z.string().nullish(),
    countryName: z.string().nullish(),
    name: z.string().nullish(),
  });
}

export function IPaymentAchInputSchema(): z.ZodObject<
  Properties<IPaymentAchInput>
> {
  return z.object({
    amount: z.string(),
    currency_code: z.string(),
  });
}

export function IPaymentInputSchema(): z.ZodObject<Properties<IPaymentInput>> {
  return z.object({
    amount: z.string(),
    currency_code: z.string().nullish(),
    gratuity_eligible_amount: z.string().nullish(),
    healthcare_amounts: z.lazy(() => IHealthcareAmountInputSchema().nullish()),
    invoice_number: z.string().nullish(),
    purchase_order: z.lazy(() => IPurchaseOrderInputSchema().nullish()),
  });
}

export function IPaymentRefundAchInputSchema(): z.ZodObject<
  Properties<IPaymentRefundAchInput>
> {
  return z.object({
    amount: z.string(),
  });
}

export function IProcessingIndicatorInputSchema(): z.ZodObject<
  Properties<IProcessingIndicatorInput>
> {
  return z.object({
    allow_duplicate: z.boolean().nullish(),
    create_token: z.boolean().nullish(),
    partial_approval: z.boolean().nullish(),
  });
}

export function IPurchaseOrderInputSchema(): z.ZodObject<
  Properties<IPurchaseOrderInput>
> {
  return z.object({
    destination_postal_code: z.string(),
    po_number: z.string(),
    tax_amount: z.string(),
  });
}

export function IReceiptInputSchema(): z.ZodObject<Properties<IReceiptInput>> {
  return z.object({
    clerk_id: z.string(),
  });
}

export function ISaleExtraInputSchema(): z.ZodObject<
  Properties<ISaleExtraInput>
> {
  return z.object({
    payment: z.lazy(() => ICountryLookupInputSchema().nullish()),
    transaction: z.lazy(() => ISaleExtraTransactionInputSchema().nullish()),
  });
}

export function ISaleExtraTransactionInputSchema(): z.ZodObject<
  Properties<ISaleExtraTransactionInput>
> {
  return z.object({
    country: z.lazy(() => ICountryLookupInputSchema().nullish()),
    language: z.lazy(() => ILanguageLookupInputSchema().nullish()),
  });
}

export function ISaleInputSchema(): z.ZodObject<Properties<ISaleInput>> {
  return z.object({
    balanceResponse: z.lazy(() =>
      CareTrackerBalanceResponseInputSchema().nullish(),
    ),
    careTrackerConsumer: z.lazy(() =>
      CareTrackerConsumerInputSchema().nullish(),
    ),
    deviceId: z.string().nullish(),
    extra: z.lazy(() => ISaleExtraInputSchema().nullish()),
    patientId: z.string().nullish(),
    payment: z.lazy(() => IPaymentInputSchema()),
    receipt: z.lazy(() => IReceiptInputSchema()),
    reference_id: z.string().nullish(),
    transaction: z.lazy(() => ITransactionInputSchema()),
    transactionId: z.string().nullish(),
  });
}

export function ITerminalInputSchema(): z.ZodObject<
  Properties<ITerminalInput>
> {
  return z.object({
    terminal_id: z.string(),
  });
}

export function ITransactionAchCanadaInputSchema(): z.ZodObject<
  Properties<ITransactionAchCanadaInput>
> {
  return z.object({
    country_code: z.string(),
    language: z.string().nullish(),
    payment_purpose_code: z.string(),
    processing_indicators: z.lazy(() =>
      IProcessingIndicatorInputSchema().nullish(),
    ),
  });
}

export function ITransactionAchInputSchema(): z.ZodObject<
  Properties<ITransactionAchInput>
> {
  return z.object({
    country_code: z.string(),
    entry_class: z.string().nullish(),
    language: z.string().nullish(),
    processing_indicators: z.lazy(() =>
      IProcessingIndicatorInputSchema().nullish(),
    ),
  });
}

export function ITransactionInputSchema(): z.ZodObject<
  Properties<ITransactionInput>
> {
  return z.object({
    country_code: z.string().nullish(),
    create_token_reason: z.string().nullish(),
    keyed_entry_mode: z.string().nullish(),
    language: z.string().nullish(),
    processing_indicators: z.lazy(() =>
      IProcessingIndicatorInputSchema().nullish(),
    ),
    terminal: z.lazy(() => ITerminalInputSchema().nullish()),
  });
}

export function ITransactionRefundAchInputSchema(): z.ZodObject<
  Properties<ITransactionRefundAchInput>
> {
  return z.object({
    entry_class: z.string().nullish(),
  });
}

export function InsuranceCompanySearchResponseFilterInputSchema(): z.ZodObject<
  Properties<InsuranceCompanySearchResponseFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => InsuranceCompanySearchResponseFilterInputSchema()))
      .nullish(),
    ediId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    formatType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    insuranceCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => InsuranceCompanySearchResponseFilterInputSchema()))
      .nullish(),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    requiresEnrollment: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
  });
}

export function InsuranceCompanySearchResponseSortInputSchema(): z.ZodObject<
  Properties<InsuranceCompanySearchResponseSortInput>
> {
  return z.object({
    ediId: SortEnumTypeSchema.nullish(),
    formatType: SortEnumTypeSchema.nullish(),
    insuranceCode: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    recId: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    requiresEnrollment: SortEnumTypeSchema.nullish(),
  });
}

export function IntOperationFilterInputSchema(): z.ZodObject<
  Properties<IntOperationFilterInput>
> {
  return z.object({
    eq: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number().nullable()).nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    neq: z.number().nullish(),
    ngt: z.number().nullish(),
    ngte: z.number().nullish(),
    nin: z.array(z.number().nullable()).nullish(),
    nlt: z.number().nullish(),
    nlte: z.number().nullish(),
  });
}

export function LineItemInputSchema(): z.ZodObject<Properties<LineItemInput>> {
  return z.object({
    accountNumber: z.string().nullish(),
    amountDue: z.string().nullish(),
    amountPaid: z.string().nullish(),
    consumerNumber: z.string().nullish(),
    ctccTransID: z.string().nullish(),
    firstName: z.string().nullish(),
    fullName: z.string().nullish(),
    gatewayRoutingCode: z.string().nullish(),
    lastName: z.string().nullish(),
    serviceDate: z.string().nullish(),
  });
}

export function ListFilterInputTypeOfBillingIdsFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfBillingIdsFilterInput>
> {
  return z.object({
    all: z.lazy(() => BillingIdsFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => BillingIdsFilterInputSchema().nullish()),
    some: z.lazy(() => BillingIdsFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfGroupEnrollmentFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfGroupEnrollmentFilterInput>
> {
  return z.object({
    all: z.lazy(() => GroupEnrollmentFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => GroupEnrollmentFilterInputSchema().nullish()),
    some: z.lazy(() => GroupEnrollmentFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfPayerRoutingFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfPayerRoutingFilterInput>
> {
  return z.object({
    all: z.lazy(() => PayerRoutingFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => PayerRoutingFilterInputSchema().nullish()),
    some: z.lazy(() => PayerRoutingFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfPreferredRoutingFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfPreferredRoutingFilterInput>
> {
  return z.object({
    all: z.lazy(() => PreferredRoutingFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => PreferredRoutingFilterInputSchema().nullish()),
    some: z.lazy(() => PreferredRoutingFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfProviderFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfProviderFilterInput>
> {
  return z.object({
    all: z.lazy(() => ProviderFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => ProviderFilterInputSchema().nullish()),
    some: z.lazy(() => ProviderFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfProviderGroupFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfProviderGroupFilterInput>
> {
  return z.object({
    all: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
    some: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfUsersClientsAcctsFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfUsersClientsAcctsFilterInput>
> {
  return z.object({
    all: z.lazy(() => UsersClientsAcctsFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => UsersClientsAcctsFilterInputSchema().nullish()),
    some: z.lazy(() => UsersClientsAcctsFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfUsersClientsAppsFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfUsersClientsAppsFilterInput>
> {
  return z.object({
    all: z.lazy(() => UsersClientsAppsFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => UsersClientsAppsFilterInputSchema().nullish()),
    some: z.lazy(() => UsersClientsAppsFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfUsersClientsGrpsFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfUsersClientsGrpsFilterInput>
> {
  return z.object({
    all: z.lazy(() => UsersClientsGrpsFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => UsersClientsGrpsFilterInputSchema().nullish()),
    some: z.lazy(() => UsersClientsGrpsFilterInputSchema().nullish()),
  });
}

export function ListFilterInputTypeOfUsersClientsPermissionsFilterInputSchema(): z.ZodObject<
  Properties<ListFilterInputTypeOfUsersClientsPermissionsFilterInput>
> {
  return z.object({
    all: z.lazy(() => UsersClientsPermissionsFilterInputSchema().nullish()),
    any: z.boolean().nullish(),
    none: z.lazy(() => UsersClientsPermissionsFilterInputSchema().nullish()),
    some: z.lazy(() => UsersClientsPermissionsFilterInputSchema().nullish()),
  });
}

export function LoginInputSchema(): z.ZodObject<Properties<LoginInput>> {
  return z.object({
    isSession: z.boolean().nullish(),
    password: z.string(),
    username: z.string(),
  });
}

export function LongOperationFilterInputSchema(): z.ZodObject<
  Properties<LongOperationFilterInput>
> {
  return z.object({
    eq: definedNonNullAnySchema.nullish(),
    gt: definedNonNullAnySchema.nullish(),
    gte: definedNonNullAnySchema.nullish(),
    in: z.array(definedNonNullAnySchema.nullable()).nullish(),
    lt: definedNonNullAnySchema.nullish(),
    lte: definedNonNullAnySchema.nullish(),
    neq: definedNonNullAnySchema.nullish(),
    ngt: definedNonNullAnySchema.nullish(),
    ngte: definedNonNullAnySchema.nullish(),
    nin: z.array(definedNonNullAnySchema.nullable()).nullish(),
    nlt: definedNonNullAnySchema.nullish(),
    nlte: definedNonNullAnySchema.nullish(),
  });
}

export function PatientFilterInputSchema(): z.ZodObject<
  Properties<PatientFilterInput>
> {
  return z.object({
    accountNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressInfoId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => PatientFilterInputSchema())).nullish(),
    contactInfoId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    createOn: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    firstName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    lastName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => PatientFilterInputSchema())).nullish(),
    parentPatientId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    patientId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    paymentCustomerId: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    providerGroupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    vendorPatientId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function PatientSortInputSchema(): z.ZodObject<
  Properties<PatientSortInput>
> {
  return z.object({
    accountNumber: SortEnumTypeSchema.nullish(),
    addressInfoId: SortEnumTypeSchema.nullish(),
    contactInfoId: SortEnumTypeSchema.nullish(),
    createOn: SortEnumTypeSchema.nullish(),
    firstName: SortEnumTypeSchema.nullish(),
    lastName: SortEnumTypeSchema.nullish(),
    parentPatientId: SortEnumTypeSchema.nullish(),
    patientId: SortEnumTypeSchema.nullish(),
    paymentCustomerId: SortEnumTypeSchema.nullish(),
    providerGroupId: SortEnumTypeSchema.nullish(),
    vendorPatientId: SortEnumTypeSchema.nullish(),
  });
}

export function PatientStatementsFilterInputSchema(): z.ZodObject<
  Properties<PatientStatementsFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => PatientStatementsFilterInputSchema())).nullish(),
    createOn: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => PatientStatementsFilterInputSchema())).nullish(),
    patientId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    patientStatementId: z.lazy(() =>
      LongOperationFilterInputSchema().nullish(),
    ),
    responsiblePartyId: z.lazy(() =>
      LongOperationFilterInputSchema().nullish(),
    ),
    statementId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
  });
}

export function PatientStatementsResponseFilterInputSchema(): z.ZodObject<
  Properties<PatientStatementsResponseFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => PatientStatementsResponseFilterInputSchema()))
      .nullish(),
    or: z
      .array(z.lazy(() => PatientStatementsResponseFilterInputSchema()))
      .nullish(),
    patientId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    patientStatementId: z.lazy(() =>
      LongOperationFilterInputSchema().nullish(),
    ),
    responsiblePartyId: z.lazy(() =>
      LongOperationFilterInputSchema().nullish(),
    ),
    statementId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
  });
}

export function PatientStatementsResponseSortInputSchema(): z.ZodObject<
  Properties<PatientStatementsResponseSortInput>
> {
  return z.object({
    patientId: SortEnumTypeSchema.nullish(),
    patientStatementId: SortEnumTypeSchema.nullish(),
    responsiblePartyId: SortEnumTypeSchema.nullish(),
    statementId: SortEnumTypeSchema.nullish(),
  });
}

export function PatientStatementsSearchFilterInputSchema(): z.ZodObject<
  Properties<PatientStatementsSearchFilterInput>
> {
  return z.object({
    patientId: definedNonNullAnySchema,
    patientStatementId: definedNonNullAnySchema,
    responsiblePartyId: definedNonNullAnySchema,
    statementId: definedNonNullAnySchema,
  });
}

export function PatientStatementsSortInputSchema(): z.ZodObject<
  Properties<PatientStatementsSortInput>
> {
  return z.object({
    createOn: SortEnumTypeSchema.nullish(),
    patientId: SortEnumTypeSchema.nullish(),
    patientStatementId: SortEnumTypeSchema.nullish(),
    responsiblePartyId: SortEnumTypeSchema.nullish(),
    statementId: SortEnumTypeSchema.nullish(),
  });
}

export function PayerFilterInputSchema(): z.ZodObject<
  Properties<PayerFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => PayerFilterInputSchema())).nullish(),
    apg: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    attachmentEnrollment: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    attachmentSplit: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    attachmentType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    attachments: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    attachmentsProcessorId: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    batchClaimStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    billingIndicator: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    cardId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    city: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimFilingIndicator: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    claimStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimStatusEnrollment: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    claimStatusId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimStatusType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactEmail: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactFax: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateLastFile: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateLastStatement: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateTerminate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dentalProcessorId: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    doesEligibility: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    eligibilityEnrollment: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    eligibilityType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    eraEnrollment: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    eraType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    followUpNumberOfDays: z.lazy(() =>
      IntOperationFilterInputSchema().nullish(),
    ),
    groupEnrolled: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groupEnrollments: z.lazy(() =>
      ListFilterInputTypeOfGroupEnrollmentFilterInputSchema().nullish(),
    ),
    icd10: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    icd10EffectiveDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    institutionalEnrollment: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    institutionalType: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    legacy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    legacyDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    neicId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    neicOffice: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    neicPayerType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nexia: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    npiIndicator: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => PayerFilterInputSchema())).nullish(),
    payorState: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    payorType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    preferredRoutings: z.lazy(() =>
      ListFilterInputTypeOfPreferredRoutingFilterInputSchema().nullish(),
    ),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    publishEra: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    publishInstitutional: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    publishProfessional: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    realTimeId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    requiresEnrollment: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    secondaryClaims: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    state: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ubProcessorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    webUrl: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    zipCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function PayerRoutingFilterInputSchema(): z.ZodObject<
  Properties<PayerRoutingFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => PayerRoutingFilterInputSchema())).nullish(),
    ediId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => PayerRoutingFilterInputSchema())).nullish(),
    processor: z.lazy(() => ProcessorFilterInputSchema().nullish()),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    scId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function PayerRoutingSortInputSchema(): z.ZodObject<
  Properties<PayerRoutingSortInput>
> {
  return z.object({
    ediId: SortEnumTypeSchema.nullish(),
    processor: z.lazy(() => ProcessorSortInputSchema().nullish()),
    processorId: SortEnumTypeSchema.nullish(),
    scId: SortEnumTypeSchema.nullish(),
  });
}

export function PayerSortInputSchema(): z.ZodObject<
  Properties<PayerSortInput>
> {
  return z.object({
    apg: SortEnumTypeSchema.nullish(),
    attachmentEnrollment: SortEnumTypeSchema.nullish(),
    attachmentSplit: SortEnumTypeSchema.nullish(),
    attachmentType: SortEnumTypeSchema.nullish(),
    attachments: SortEnumTypeSchema.nullish(),
    attachmentsProcessorId: SortEnumTypeSchema.nullish(),
    batchClaimStatus: SortEnumTypeSchema.nullish(),
    billingIndicator: SortEnumTypeSchema.nullish(),
    cardId: SortEnumTypeSchema.nullish(),
    city: SortEnumTypeSchema.nullish(),
    claimFilingIndicator: SortEnumTypeSchema.nullish(),
    claimStatus: SortEnumTypeSchema.nullish(),
    claimStatusEnrollment: SortEnumTypeSchema.nullish(),
    claimStatusId: SortEnumTypeSchema.nullish(),
    claimStatusType: SortEnumTypeSchema.nullish(),
    contactEmail: SortEnumTypeSchema.nullish(),
    contactFax: SortEnumTypeSchema.nullish(),
    contactName: SortEnumTypeSchema.nullish(),
    contactPhone: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateLastFile: SortEnumTypeSchema.nullish(),
    dateLastStatement: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    dateTerminate: SortEnumTypeSchema.nullish(),
    dentalProcessorId: SortEnumTypeSchema.nullish(),
    doesEligibility: SortEnumTypeSchema.nullish(),
    eligibilityEnrollment: SortEnumTypeSchema.nullish(),
    eligibilityType: SortEnumTypeSchema.nullish(),
    eraEnrollment: SortEnumTypeSchema.nullish(),
    eraType: SortEnumTypeSchema.nullish(),
    followUpNumberOfDays: SortEnumTypeSchema.nullish(),
    groupEnrolled: SortEnumTypeSchema.nullish(),
    icd10: SortEnumTypeSchema.nullish(),
    icd10EffectiveDate: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    institutionalEnrollment: SortEnumTypeSchema.nullish(),
    institutionalType: SortEnumTypeSchema.nullish(),
    legacy: SortEnumTypeSchema.nullish(),
    legacyDbUpdate: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    neicId: SortEnumTypeSchema.nullish(),
    neicOffice: SortEnumTypeSchema.nullish(),
    neicPayerType: SortEnumTypeSchema.nullish(),
    nexia: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    npiIndicator: SortEnumTypeSchema.nullish(),
    payorState: SortEnumTypeSchema.nullish(),
    payorType: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    publishEra: SortEnumTypeSchema.nullish(),
    publishInstitutional: SortEnumTypeSchema.nullish(),
    publishProfessional: SortEnumTypeSchema.nullish(),
    realTimeId: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    requiresEnrollment: SortEnumTypeSchema.nullish(),
    secondaryClaims: SortEnumTypeSchema.nullish(),
    state: SortEnumTypeSchema.nullish(),
    ubProcessorId: SortEnumTypeSchema.nullish(),
    webUrl: SortEnumTypeSchema.nullish(),
    zipCode: SortEnumTypeSchema.nullish(),
  });
}

export function PayloadInputSchema(): z.ZodObject<Properties<PayloadInput>> {
  return z.object({
    consumerNumber: z.string().nullish(),
    dataContext: z.lazy(() => DataContextInputSchema().nullish()),
    deepLink: z.string().nullish(),
    externalUsername: z.string().nullish(),
    groupSiteName: z.string().nullish(),
    orgSiteName: z.string().nullish(),
    password: z.string().nullish(),
    roleName: z.string().nullish(),
    userEmail: z.string().nullish(),
    userFirstName: z.string().nullish(),
    userLastName: z.string().nullish(),
    username: z.string().nullish(),
  });
}

export function PaymentsRecurringPaymentFilterInputSchema(): z.ZodObject<
  Properties<PaymentsRecurringPaymentFilterInput>
> {
  return z.object({
    amount: z.lazy(() => DecimalOperationFilterInputSchema().nullish()),
    and: z
      .array(z.lazy(() => PaymentsRecurringPaymentFilterInputSchema()))
      .nullish(),
    isActive: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => PaymentsRecurringPaymentFilterInputSchema()))
      .nullish(),
    patientId: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    paymentPlan: z.lazy(() =>
      PaymentsRecurringPaymentPlanOperationFilterInputSchema().nullish(),
    ),
    recurringPaymentId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    startDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
  });
}

export function PaymentsRecurringPaymentPlanOperationFilterInputSchema(): z.ZodObject<
  Properties<PaymentsRecurringPaymentPlanOperationFilterInput>
> {
  return z.object({
    eq: PaymentsRecurringPaymentPlanSchema.nullish(),
    in: z.array(PaymentsRecurringPaymentPlanSchema).nullish(),
    neq: PaymentsRecurringPaymentPlanSchema.nullish(),
    nin: z.array(PaymentsRecurringPaymentPlanSchema).nullish(),
  });
}

export function PaymentsRecurringPaymentSortInputSchema(): z.ZodObject<
  Properties<PaymentsRecurringPaymentSortInput>
> {
  return z.object({
    amount: SortEnumTypeSchema.nullish(),
    isActive: SortEnumTypeSchema.nullish(),
    patientId: SortEnumTypeSchema.nullish(),
    paymentPlan: SortEnumTypeSchema.nullish(),
    recurringPaymentId: SortEnumTypeSchema.nullish(),
    startDate: SortEnumTypeSchema.nullish(),
  });
}

export function PermissionsFilterInputSchema(): z.ZodObject<
  Properties<PermissionsFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => PermissionsFilterInputSchema())).nullish(),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => PermissionsFilterInputSchema())).nullish(),
    usersClientsPermissions: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsPermissionsFilterInputSchema().nullish(),
    ),
  });
}

export function PermissionsSortInputSchema(): z.ZodObject<
  Properties<PermissionsSortInput>
> {
  return z.object({
    id: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
  });
}

export function PreferredRoutingFilterInputSchema(): z.ZodObject<
  Properties<PreferredRoutingFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => PreferredRoutingFilterInputSchema())).nullish(),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    doc1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    doc2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    doc3: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    doc4: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    doc5: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    enrollmentType: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    lastUpdatedBy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => PreferredRoutingFilterInputSchema())).nullish(),
    payer: z.lazy(() => PayerFilterInputSchema().nullish()),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    scId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    url: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function PreferredRoutingSortInputSchema(): z.ZodObject<
  Properties<PreferredRoutingSortInput>
> {
  return z.object({
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    doc1: SortEnumTypeSchema.nullish(),
    doc2: SortEnumTypeSchema.nullish(),
    doc3: SortEnumTypeSchema.nullish(),
    doc4: SortEnumTypeSchema.nullish(),
    doc5: SortEnumTypeSchema.nullish(),
    enrollmentType: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    lastUpdatedBy: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    payer: z.lazy(() => PayerSortInputSchema().nullish()),
    processorId: SortEnumTypeSchema.nullish(),
    scId: SortEnumTypeSchema.nullish(),
    url: SortEnumTypeSchema.nullish(),
  });
}

export function ProcessorFilterInputSchema(): z.ZodObject<
  Properties<ProcessorFilterInput>
> {
  return z.object({
    acknowledgementFormat: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    acknowledgmentRequested: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    addressCity: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressState: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressZipcode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => ProcessorFilterInputSchema())).nullish(),
    billingMethod: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactEmail: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactFax: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateLastFile: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateLastStatement: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateLastTransmit: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateTerminate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    ediFormat: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ediReceiverId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ediSubmitterId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    format: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ftpKey: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    generateRemit: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    gs02AppSenderCode: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    gs03AppReceiverCode: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa05IdQual: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa07IdQual: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa11identifier: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isaAuthInfo: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isaAuthInfoQual: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isasecInfo: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isasecInfoQual: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    mappingFilePath4010: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    mappingFilePath5010: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nm103Orgname: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nm109IdCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nm1091000bCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nsfFileNumber: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    nsfStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    oneStSePerClaim: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ProcessorFilterInputSchema())).nullish(),
    payerRoutings: z.lazy(() =>
      ListFilterInputTypeOfPayerRoutingFilterInputSchema().nullish(),
    ),
    per02Name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    per03CommQual1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    per04CommNum1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    per05CommQual2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    per06CommNum2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    requiresSubmitter: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    singleSubmitter: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    statementMethod: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    technicalContact: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    technicalPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ProcessorSortInputSchema(): z.ZodObject<
  Properties<ProcessorSortInput>
> {
  return z.object({
    acknowledgementFormat: SortEnumTypeSchema.nullish(),
    acknowledgmentRequested: SortEnumTypeSchema.nullish(),
    addressCity: SortEnumTypeSchema.nullish(),
    addressLine1: SortEnumTypeSchema.nullish(),
    addressLine2: SortEnumTypeSchema.nullish(),
    addressState: SortEnumTypeSchema.nullish(),
    addressZipcode: SortEnumTypeSchema.nullish(),
    billingMethod: SortEnumTypeSchema.nullish(),
    contactEmail: SortEnumTypeSchema.nullish(),
    contactFax: SortEnumTypeSchema.nullish(),
    contactName: SortEnumTypeSchema.nullish(),
    contactPhone: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateLastFile: SortEnumTypeSchema.nullish(),
    dateLastStatement: SortEnumTypeSchema.nullish(),
    dateLastTransmit: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    dateTerminate: SortEnumTypeSchema.nullish(),
    ediFormat: SortEnumTypeSchema.nullish(),
    ediReceiverId: SortEnumTypeSchema.nullish(),
    ediSubmitterId: SortEnumTypeSchema.nullish(),
    format: SortEnumTypeSchema.nullish(),
    ftpKey: SortEnumTypeSchema.nullish(),
    generateRemit: SortEnumTypeSchema.nullish(),
    gs02AppSenderCode: SortEnumTypeSchema.nullish(),
    gs03AppReceiverCode: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    isa05IdQual: SortEnumTypeSchema.nullish(),
    isa07IdQual: SortEnumTypeSchema.nullish(),
    isa11identifier: SortEnumTypeSchema.nullish(),
    isaAuthInfo: SortEnumTypeSchema.nullish(),
    isaAuthInfoQual: SortEnumTypeSchema.nullish(),
    isasecInfo: SortEnumTypeSchema.nullish(),
    isasecInfoQual: SortEnumTypeSchema.nullish(),
    mappingFilePath4010: SortEnumTypeSchema.nullish(),
    mappingFilePath5010: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    nm103Orgname: SortEnumTypeSchema.nullish(),
    nm109IdCode: SortEnumTypeSchema.nullish(),
    nm1091000bCode: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    nsfFileNumber: SortEnumTypeSchema.nullish(),
    nsfStatus: SortEnumTypeSchema.nullish(),
    oneStSePerClaim: SortEnumTypeSchema.nullish(),
    per02Name: SortEnumTypeSchema.nullish(),
    per03CommQual1: SortEnumTypeSchema.nullish(),
    per04CommNum1: SortEnumTypeSchema.nullish(),
    per05CommQual2: SortEnumTypeSchema.nullish(),
    per06CommNum2: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    requiresSubmitter: SortEnumTypeSchema.nullish(),
    singleSubmitter: SortEnumTypeSchema.nullish(),
    statementMethod: SortEnumTypeSchema.nullish(),
    technicalContact: SortEnumTypeSchema.nullish(),
    technicalPhone: SortEnumTypeSchema.nullish(),
  });
}

export function ProviderFilterInputSchema(): z.ZodObject<
  Properties<ProviderFilterInput>
> {
  return z.object({
    account: z.lazy(() => AccountFilterInputSchema().nullish()),
    accountNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressCity: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressState: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressZipcode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => ProviderFilterInputSchema())).nullish(),
    application: z.lazy(() => ApplicationFilterInputSchema().nullish()),
    billingMethod: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    certified: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimRoutingMethod: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    claimStatusDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    claimStatusStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    contactEmail: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactFax: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactTitle: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateLastCertified: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateLastClaim: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateLastStatement: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateTerminate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    degree: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    ecsDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    ecsStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    eligibilityDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    eligibilityStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    eraDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    eraStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    feeSchedule: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    firstName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groupEnrollments: z.lazy(() =>
      ListFilterInputTypeOfGroupEnrollmentFilterInputSchema().nullish(),
    ),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    lastName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    lastUpdatedBy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    mailboxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    mi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    neicId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    neicSiteId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nsfBatchNumber: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ProviderFilterInputSchema())).nullish(),
    organizationName: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    organizationType: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    pcMemory: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    pms: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    pmsSoftware: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providerGroup: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
    providerGroupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    statementDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    statementMethod: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    statementStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    submitterNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function ProviderGroupFilterInputSchema(): z.ZodObject<
  Properties<ProviderGroupFilterInput>
> {
  return z.object({
    account: z.lazy(() => AccountFilterInputSchema().nullish()),
    accountCredentialKey: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    accountNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    achCredentialKey: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    addressCity: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine1: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressLine2: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressState: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    addressZipcode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    allowACH: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    alphaII: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => ProviderGroupFilterInputSchema())).nullish(),
    appSenderCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    backLink: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batch277ca: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batch277u: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batchCSV: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    batchHumanReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    batchMachineReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    batchXml: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    billingIds: z.lazy(() =>
      ListFilterInputTypeOfBillingIdsFilterInputSchema().nullish(),
    ),
    billingMethod: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    certified: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    claimStatusDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    claimStatusStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    clientVersion: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    combineERA: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactEmail: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactFax: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    contactTitle: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateLastCertified: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateLastClaim: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateLastDbUpdate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    dateTerminated: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    ecsDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    ecsStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    eligibilityDate: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    eligibilityStatus: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    eraDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    eraFileSeqNum: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    eraStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    feeSchedule: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    fees: z.lazy(() => FeeFilterInputSchema().nullish()),
    ftpKey: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    genericProvider: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    glueEM: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groupEnrollments: z.lazy(() =>
      ListFilterInputTypeOfGroupEnrollmentFilterInputSchema().nullish(),
    ),
    groupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    humanReadable271: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    inputGenerates999: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    instAppSenderCode: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    instNM109IdCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    instProcessorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    instSubmitterId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    interchangeNum: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    isDev: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    lastUpdatedBy: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    lockBox: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    lockboxProcessorId: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    mailboxId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    newStatements: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    nm109IdCode: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    notes: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ProviderGroupFilterInputSchema())).nullish(),
    organizationType: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    partialRedirectInstitutional: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    partialRedirectProfessional: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    pmIdentifier: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    pms: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    pmsSoftware: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    providers: z.lazy(() =>
      ListFilterInputTypeOfProviderFilterInputSchema().nullish(),
    ),
    rcm: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    recordStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    rejectPrintClaims: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    remit277ca: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remit277u: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitCSVDaily: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitCsv: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitEraSummary: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    remitHumanReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    remitMachineReadable: z.lazy(() =>
      StringOperationFilterInputSchema().nullish(),
    ),
    remitXml: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    reportNumber: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    statementDate: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    statementMethod: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    statementStatus: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    submitterId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    universalReport: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    usersClientsGrps: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsGrpsFilterInputSchema().nullish(),
    ),
  });
}

export function ProviderGroupSortInputSchema(): z.ZodObject<
  Properties<ProviderGroupSortInput>
> {
  return z.object({
    account: z.lazy(() => AccountSortInputSchema().nullish()),
    accountCredentialKey: SortEnumTypeSchema.nullish(),
    accountNumber: SortEnumTypeSchema.nullish(),
    achCredentialKey: SortEnumTypeSchema.nullish(),
    addressCity: SortEnumTypeSchema.nullish(),
    addressLine1: SortEnumTypeSchema.nullish(),
    addressLine2: SortEnumTypeSchema.nullish(),
    addressState: SortEnumTypeSchema.nullish(),
    addressZipcode: SortEnumTypeSchema.nullish(),
    allowACH: SortEnumTypeSchema.nullish(),
    alphaII: SortEnumTypeSchema.nullish(),
    appSenderCode: SortEnumTypeSchema.nullish(),
    backLink: SortEnumTypeSchema.nullish(),
    batch277ca: SortEnumTypeSchema.nullish(),
    batch277u: SortEnumTypeSchema.nullish(),
    batchCSV: SortEnumTypeSchema.nullish(),
    batchHumanReadable: SortEnumTypeSchema.nullish(),
    batchMachineReadable: SortEnumTypeSchema.nullish(),
    batchXml: SortEnumTypeSchema.nullish(),
    billingMethod: SortEnumTypeSchema.nullish(),
    certified: SortEnumTypeSchema.nullish(),
    claimStatusDate: SortEnumTypeSchema.nullish(),
    claimStatusStatus: SortEnumTypeSchema.nullish(),
    clientVersion: SortEnumTypeSchema.nullish(),
    combineERA: SortEnumTypeSchema.nullish(),
    contactEmail: SortEnumTypeSchema.nullish(),
    contactFax: SortEnumTypeSchema.nullish(),
    contactName: SortEnumTypeSchema.nullish(),
    contactPhone: SortEnumTypeSchema.nullish(),
    contactTitle: SortEnumTypeSchema.nullish(),
    dateLastCertified: SortEnumTypeSchema.nullish(),
    dateLastClaim: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    dateTerminated: SortEnumTypeSchema.nullish(),
    ecsDate: SortEnumTypeSchema.nullish(),
    ecsStatus: SortEnumTypeSchema.nullish(),
    eligibilityDate: SortEnumTypeSchema.nullish(),
    eligibilityStatus: SortEnumTypeSchema.nullish(),
    eraDate: SortEnumTypeSchema.nullish(),
    eraFileSeqNum: SortEnumTypeSchema.nullish(),
    eraStatus: SortEnumTypeSchema.nullish(),
    feeSchedule: SortEnumTypeSchema.nullish(),
    fees: z.lazy(() => FeeSortInputSchema().nullish()),
    ftpKey: SortEnumTypeSchema.nullish(),
    genericProvider: SortEnumTypeSchema.nullish(),
    glueEM: SortEnumTypeSchema.nullish(),
    groupId: SortEnumTypeSchema.nullish(),
    humanReadable271: SortEnumTypeSchema.nullish(),
    inputGenerates999: SortEnumTypeSchema.nullish(),
    instAppSenderCode: SortEnumTypeSchema.nullish(),
    instNM109IdCode: SortEnumTypeSchema.nullish(),
    instProcessorId: SortEnumTypeSchema.nullish(),
    instSubmitterId: SortEnumTypeSchema.nullish(),
    interchangeNum: SortEnumTypeSchema.nullish(),
    isDev: SortEnumTypeSchema.nullish(),
    lastUpdatedBy: SortEnumTypeSchema.nullish(),
    lockBox: SortEnumTypeSchema.nullish(),
    lockboxProcessorId: SortEnumTypeSchema.nullish(),
    mailboxId: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
    newStatements: SortEnumTypeSchema.nullish(),
    nm109IdCode: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    organizationType: SortEnumTypeSchema.nullish(),
    partialRedirectInstitutional: SortEnumTypeSchema.nullish(),
    partialRedirectProfessional: SortEnumTypeSchema.nullish(),
    pmIdentifier: SortEnumTypeSchema.nullish(),
    pms: SortEnumTypeSchema.nullish(),
    pmsSoftware: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    rcm: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    rejectPrintClaims: SortEnumTypeSchema.nullish(),
    remit277ca: SortEnumTypeSchema.nullish(),
    remit277u: SortEnumTypeSchema.nullish(),
    remitCSVDaily: SortEnumTypeSchema.nullish(),
    remitCsv: SortEnumTypeSchema.nullish(),
    remitEraSummary: SortEnumTypeSchema.nullish(),
    remitHumanReadable: SortEnumTypeSchema.nullish(),
    remitMachineReadable: SortEnumTypeSchema.nullish(),
    remitXml: SortEnumTypeSchema.nullish(),
    reportNumber: SortEnumTypeSchema.nullish(),
    statementDate: SortEnumTypeSchema.nullish(),
    statementMethod: SortEnumTypeSchema.nullish(),
    statementStatus: SortEnumTypeSchema.nullish(),
    submitterId: SortEnumTypeSchema.nullish(),
    universalReport: SortEnumTypeSchema.nullish(),
  });
}

export function ProviderSortInputSchema(): z.ZodObject<
  Properties<ProviderSortInput>
> {
  return z.object({
    account: z.lazy(() => AccountSortInputSchema().nullish()),
    accountNumber: SortEnumTypeSchema.nullish(),
    addressCity: SortEnumTypeSchema.nullish(),
    addressLine1: SortEnumTypeSchema.nullish(),
    addressLine2: SortEnumTypeSchema.nullish(),
    addressState: SortEnumTypeSchema.nullish(),
    addressZipcode: SortEnumTypeSchema.nullish(),
    application: z.lazy(() => ApplicationSortInputSchema().nullish()),
    billingMethod: SortEnumTypeSchema.nullish(),
    certified: SortEnumTypeSchema.nullish(),
    claimRoutingMethod: SortEnumTypeSchema.nullish(),
    claimStatusDate: SortEnumTypeSchema.nullish(),
    claimStatusStatus: SortEnumTypeSchema.nullish(),
    contactEmail: SortEnumTypeSchema.nullish(),
    contactFax: SortEnumTypeSchema.nullish(),
    contactName: SortEnumTypeSchema.nullish(),
    contactPhone: SortEnumTypeSchema.nullish(),
    contactTitle: SortEnumTypeSchema.nullish(),
    dateLastCertified: SortEnumTypeSchema.nullish(),
    dateLastClaim: SortEnumTypeSchema.nullish(),
    dateLastDbUpdate: SortEnumTypeSchema.nullish(),
    dateLastStatement: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    dateTerminate: SortEnumTypeSchema.nullish(),
    degree: SortEnumTypeSchema.nullish(),
    ecsDate: SortEnumTypeSchema.nullish(),
    ecsStatus: SortEnumTypeSchema.nullish(),
    eligibilityDate: SortEnumTypeSchema.nullish(),
    eligibilityStatus: SortEnumTypeSchema.nullish(),
    eraDate: SortEnumTypeSchema.nullish(),
    eraStatus: SortEnumTypeSchema.nullish(),
    feeSchedule: SortEnumTypeSchema.nullish(),
    firstName: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    lastName: SortEnumTypeSchema.nullish(),
    lastUpdatedBy: SortEnumTypeSchema.nullish(),
    mailboxId: SortEnumTypeSchema.nullish(),
    mi: SortEnumTypeSchema.nullish(),
    neicId: SortEnumTypeSchema.nullish(),
    neicSiteId: SortEnumTypeSchema.nullish(),
    notes: SortEnumTypeSchema.nullish(),
    nsfBatchNumber: SortEnumTypeSchema.nullish(),
    organizationName: SortEnumTypeSchema.nullish(),
    organizationType: SortEnumTypeSchema.nullish(),
    pcMemory: SortEnumTypeSchema.nullish(),
    pms: SortEnumTypeSchema.nullish(),
    pmsSoftware: SortEnumTypeSchema.nullish(),
    providerGroup: z.lazy(() => ProviderGroupSortInputSchema().nullish()),
    providerGroupId: SortEnumTypeSchema.nullish(),
    recordStatus: SortEnumTypeSchema.nullish(),
    statementDate: SortEnumTypeSchema.nullish(),
    statementMethod: SortEnumTypeSchema.nullish(),
    statementStatus: SortEnumTypeSchema.nullish(),
    submitterNumber: SortEnumTypeSchema.nullish(),
  });
}

export function QualifierFilterInputSchema(): z.ZodObject<
  Properties<QualifierFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => QualifierFilterInputSchema())).nullish(),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => QualifierFilterInputSchema())).nullish(),
  });
}

export function QualifierSortInputSchema(): z.ZodObject<
  Properties<QualifierSortInput>
> {
  return z.object({
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
  });
}

export function RealTimeProcessorFilterInputSchema(): z.ZodObject<
  Properties<RealTimeProcessorFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => RealTimeProcessorFilterInputSchema())).nullish(),
    contactPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    gs02: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    gs03: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa01: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa02: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa03: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa04: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa05: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa06: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa07: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa08: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa11: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isa12: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => RealTimeProcessorFilterInputSchema())).nullish(),
  });
}

export function RealTimeProcessorSortInputSchema(): z.ZodObject<
  Properties<RealTimeProcessorSortInput>
> {
  return z.object({
    contactPhone: SortEnumTypeSchema.nullish(),
    gs02: SortEnumTypeSchema.nullish(),
    gs03: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    isa01: SortEnumTypeSchema.nullish(),
    isa02: SortEnumTypeSchema.nullish(),
    isa03: SortEnumTypeSchema.nullish(),
    isa04: SortEnumTypeSchema.nullish(),
    isa05: SortEnumTypeSchema.nullish(),
    isa06: SortEnumTypeSchema.nullish(),
    isa07: SortEnumTypeSchema.nullish(),
    isa08: SortEnumTypeSchema.nullish(),
    isa11: SortEnumTypeSchema.nullish(),
    isa12: SortEnumTypeSchema.nullish(),
    name: SortEnumTypeSchema.nullish(),
  });
}

export function RecurringPaymentInputSchema(): z.ZodObject<
  Properties<RecurringPaymentInput>
> {
  return z.object({
    amount: definedNonNullAnySchema,
    patient_id: z.number(),
    payment_plan: PaymentsRecurringPaymentPlanSchema,
    startdate: definedNonNullAnySchema,
  });
}

export function SecureConnectClaimStatusTypesOperationFilterInputSchema(): z.ZodObject<
  Properties<SecureConnectClaimStatusTypesOperationFilterInput>
> {
  return z.object({
    eq: SecureConnectClaimStatusTypesSchema.nullish(),
    in: z.array(SecureConnectClaimStatusTypesSchema).nullish(),
    neq: SecureConnectClaimStatusTypesSchema.nullish(),
    nin: z.array(SecureConnectClaimStatusTypesSchema).nullish(),
  });
}

export function StatesFilterInputSchema(): z.ZodObject<
  Properties<StatesFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => StatesFilterInputSchema())).nullish(),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    description: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => StatesFilterInputSchema())).nullish(),
  });
}

export function StatesSortInputSchema(): z.ZodObject<
  Properties<StatesSortInput>
> {
  return z.object({
    code: SortEnumTypeSchema.nullish(),
    description: SortEnumTypeSchema.nullish(),
  });
}

export function StatisticsBaseFilterInputSchema(): z.ZodObject<
  Properties<StatisticsBaseFilterInput>
> {
  return z.object({
    accountNumber: z.string().nullish(),
    groupId: z.string().nullish(),
    pms: z.string().nullish(),
  });
}

export function StatisticsMissingClaimResponseFilterInputSchema(): z.ZodObject<
  Properties<StatisticsMissingClaimResponseFilterInput>
> {
  return z.object({
    accountNumber: z.string().nullish(),
    groupId: z.string().nullish(),
    pms: z.string().nullish(),
    submissionDate: definedNonNullAnySchema.nullish(),
    type: z.string(),
  });
}

export function StatisticsRangeSearchFilterInputSchema(): z.ZodObject<
  Properties<StatisticsRangeSearchFilterInput>
> {
  return z.object({
    accountNumber: z.string().nullish(),
    groupId: z.string().nullish(),
    pms: z.string().nullish(),
    submissionDateFrom: definedNonNullAnySchema.nullish(),
    submissionDateTo: definedNonNullAnySchema.nullish(),
  });
}

export function StatisticsRevSpringFilterInputSchema(): z.ZodObject<
  Properties<StatisticsRevSpringFilterInput>
> {
  return z.object({
    accountNumber: z.string().nullish(),
    balanced: z.string().nullish(),
    companyId: z.string().nullish(),
    groupId: z.string().nullish(),
    pms: z.string().nullish(),
    submissionDateFrom: definedNonNullAnySchema.nullish(),
    submissionDateTo: definedNonNullAnySchema.nullish(),
  });
}

export function StatisticsSearchFilterInputSchema(): z.ZodObject<
  Properties<StatisticsSearchFilterInput>
> {
  return z.object({
    accountNumber: z.string().nullish(),
    groupId: z.string().nullish(),
    pms: z.string().nullish(),
    submissionDate: definedNonNullAnySchema.nullish(),
  });
}

export function StringOperationFilterInputSchema(): z.ZodObject<
  Properties<StringOperationFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => StringOperationFilterInputSchema())).nullish(),
    contains: z.string().nullish(),
    endsWith: z.string().nullish(),
    eq: z.string().nullish(),
    in: z.array(z.string().nullable()).nullish(),
    ncontains: z.string().nullish(),
    nendsWith: z.string().nullish(),
    neq: z.string().nullish(),
    nin: z.array(z.string().nullable()).nullish(),
    nstartsWith: z.string().nullish(),
    or: z.array(z.lazy(() => StringOperationFilterInputSchema())).nullish(),
    startsWith: z.string().nullish(),
  });
}

export function SubmitterIdsFilterInputSchema(): z.ZodObject<
  Properties<SubmitterIdsFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => SubmitterIdsFilterInputSchema())).nullish(),
    billingNpi: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    dateSetup: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => SubmitterIdsFilterInputSchema())).nullish(),
    processorId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    submitterId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function SubmitterIdsSortInputSchema(): z.ZodObject<
  Properties<SubmitterIdsSortInput>
> {
  return z.object({
    billingNpi: SortEnumTypeSchema.nullish(),
    dateSetup: SortEnumTypeSchema.nullish(),
    processorId: SortEnumTypeSchema.nullish(),
    submitterId: SortEnumTypeSchema.nullish(),
  });
}

export function ThirdPartyBalanceResponseInputSchema(): z.ZodObject<
  Properties<ThirdPartyBalanceResponseInput>
> {
  return z.object({
    response: z.lazy(() => Ct_BalanceResponseInputSchema().nullish()),
    tranId: z.string().nullish(),
    transaction_id: z.string().nullish(),
  });
}

export function ThirdPartyConsumerObjectInputSchema(): z.ZodObject<
  Properties<ThirdPartyConsumerObjectInput>
> {
  return z.object({
    payload: z.lazy(() => PayloadInputSchema().nullish()),
  });
}

export function ThirdPartyCookiesInputSchema(): z.ZodObject<
  Properties<ThirdPartyCookiesInput>
> {
  return z.object({
    issuer: z.string(),
    user: z.string(),
  });
}

export function TwoFactorAuthenticationCodeInputSchema(): z.ZodObject<
  Properties<TwoFactorAuthenticationCodeInput>
> {
  return z.object({
    code: z.string(),
    secret: z.string().nullish(),
  });
}

export function TwoFactorAuthenticationInputSchema(): z.ZodObject<
  Properties<TwoFactorAuthenticationInput>
> {
  return z.object({
    secret: z.string(),
  });
}

export function UserResponseSortInputSchema(): z.ZodObject<
  Properties<UserResponseSortInput>
> {
  return z.object({
    accessLevel: SortEnumTypeSchema.nullish(),
    active: SortEnumTypeSchema.nullish(),
    cellPhone: SortEnumTypeSchema.nullish(),
    createdAt: SortEnumTypeSchema.nullish(),
    createdBy: SortEnumTypeSchema.nullish(),
    ext: SortEnumTypeSchema.nullish(),
    firstName: SortEnumTypeSchema.nullish(),
    groupId: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    identityUserId: SortEnumTypeSchema.nullish(),
    lastName: SortEnumTypeSchema.nullish(),
    passwordLastUpdated: SortEnumTypeSchema.nullish(),
    passwordResetAllowed: SortEnumTypeSchema.nullish(),
    phone: SortEnumTypeSchema.nullish(),
    pin: SortEnumTypeSchema.nullish(),
    role: SortEnumTypeSchema.nullish(),
    updatedAt: SortEnumTypeSchema.nullish(),
    updatedBy: SortEnumTypeSchema.nullish(),
    userName: SortEnumTypeSchema.nullish(),
  });
}

export function UsersClientsAcctsFilterInputSchema(): z.ZodObject<
  Properties<UsersClientsAcctsFilterInput>
> {
  return z.object({
    account: z.lazy(() => AccountFilterInputSchema().nullish()),
    accountNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => UsersClientsAcctsFilterInputSchema())).nullish(),
    id: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => UsersClientsAcctsFilterInputSchema())).nullish(),
    userClientId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    usersClients: z.lazy(() => UsersClientsFilterInputSchema().nullish()),
  });
}

export function UsersClientsAppsFilterInputSchema(): z.ZodObject<
  Properties<UsersClientsAppsFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => UsersClientsAppsFilterInputSchema())).nullish(),
    application: z.lazy(() => ApplicationFilterInputSchema().nullish()),
    applicationId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => UsersClientsAppsFilterInputSchema())).nullish(),
    userClientId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    usersClients: z.lazy(() => UsersClientsFilterInputSchema().nullish()),
  });
}

export function UsersClientsFilterInputSchema(): z.ZodObject<
  Properties<UsersClientsFilterInput>
> {
  return z.object({
    accessLevel: z.lazy(() =>
      AccessLevelsOperationFilterInputSchema().nullish(),
    ),
    accounts: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsAcctsFilterInputSchema().nullish(),
    ),
    active: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => UsersClientsFilterInputSchema())).nullish(),
    applications: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsAppsFilterInputSchema().nullish(),
    ),
    caseNumber: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    cellPhone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    createdBy: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    ext: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    firstName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    groups: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsGrpsFilterInputSchema().nullish(),
    ),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    identityUserId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    isUser: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    lastName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => UsersClientsFilterInputSchema())).nullish(),
    passwordLastUpdated: z.lazy(() =>
      DateTimeOperationFilterInputSchema().nullish(),
    ),
    passwordResetAllowed: z.lazy(() =>
      BooleanOperationFilterInputSchema().nullish(),
    ),
    permissions: z.lazy(() =>
      ListFilterInputTypeOfUsersClientsPermissionsFilterInputSchema().nullish(),
    ),
    phone: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    pin: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    role: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    updatedBy: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    userName: z.lazy(() => StringOperationFilterInputSchema().nullish()),
  });
}

export function UsersClientsGrpsFilterInputSchema(): z.ZodObject<
  Properties<UsersClientsGrpsFilterInput>
> {
  return z.object({
    and: z.array(z.lazy(() => UsersClientsGrpsFilterInputSchema())).nullish(),
    group: z.lazy(() => ProviderGroupFilterInputSchema().nullish()),
    groupId: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    id: z.lazy(() => LongOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => UsersClientsGrpsFilterInputSchema())).nullish(),
    userClientId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    usersClients: z.lazy(() => UsersClientsFilterInputSchema().nullish()),
  });
}

export function UsersClientsPermissionsFilterInputSchema(): z.ZodObject<
  Properties<UsersClientsPermissionsFilterInput>
> {
  return z.object({
    and: z
      .array(z.lazy(() => UsersClientsPermissionsFilterInputSchema()))
      .nullish(),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    name: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    or: z
      .array(z.lazy(() => UsersClientsPermissionsFilterInputSchema()))
      .nullish(),
    permission: z.lazy(() => PermissionsFilterInputSchema().nullish()),
    permissionId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    userId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    usersClients: z.lazy(() => UsersClientsFilterInputSchema().nullish()),
  });
}

export function UsersClientsSortInputSchema(): z.ZodObject<
  Properties<UsersClientsSortInput>
> {
  return z.object({
    accessLevel: SortEnumTypeSchema.nullish(),
    active: SortEnumTypeSchema.nullish(),
    caseNumber: SortEnumTypeSchema.nullish(),
    cellPhone: SortEnumTypeSchema.nullish(),
    createdAt: SortEnumTypeSchema.nullish(),
    createdBy: SortEnumTypeSchema.nullish(),
    ext: SortEnumTypeSchema.nullish(),
    firstName: SortEnumTypeSchema.nullish(),
    groupId: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    identityUserId: SortEnumTypeSchema.nullish(),
    isUser: SortEnumTypeSchema.nullish(),
    lastName: SortEnumTypeSchema.nullish(),
    passwordLastUpdated: SortEnumTypeSchema.nullish(),
    passwordResetAllowed: SortEnumTypeSchema.nullish(),
    phone: SortEnumTypeSchema.nullish(),
    pin: SortEnumTypeSchema.nullish(),
    role: SortEnumTypeSchema.nullish(),
    updatedAt: SortEnumTypeSchema.nullish(),
    updatedBy: SortEnumTypeSchema.nullish(),
    userName: SortEnumTypeSchema.nullish(),
  });
}

export function ZipcodeFilterInputSchema(): z.ZodObject<
  Properties<ZipcodeFilterInput>
> {
  return z.object({
    active: z.lazy(() => BooleanOperationFilterInputSchema().nullish()),
    and: z.array(z.lazy(() => ZipcodeFilterInputSchema())).nullish(),
    city: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    code: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    createdAt: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    createdBy: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    id: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    or: z.array(z.lazy(() => ZipcodeFilterInputSchema())).nullish(),
    state: z.lazy(() => StringOperationFilterInputSchema().nullish()),
    timezoneId: z.lazy(() => IntOperationFilterInputSchema().nullish()),
    updatedAt: z.lazy(() => DateTimeOperationFilterInputSchema().nullish()),
    updatedBy: z.lazy(() => IntOperationFilterInputSchema().nullish()),
  });
}

export function ZipcodeSortInputSchema(): z.ZodObject<
  Properties<ZipcodeSortInput>
> {
  return z.object({
    active: SortEnumTypeSchema.nullish(),
    city: SortEnumTypeSchema.nullish(),
    code: SortEnumTypeSchema.nullish(),
    createdAt: SortEnumTypeSchema.nullish(),
    createdBy: SortEnumTypeSchema.nullish(),
    id: SortEnumTypeSchema.nullish(),
    state: SortEnumTypeSchema.nullish(),
    timezoneId: SortEnumTypeSchema.nullish(),
    updatedAt: SortEnumTypeSchema.nullish(),
    updatedBy: SortEnumTypeSchema.nullish(),
  });
}
